import { QueryClient } from '@tanstack/react-query'
import { AxiosError, isAxiosError } from 'axios'
import { defaultQueryFunction } from '../lib/api'

const MAX_RETRIES = 3

export const shouldRetry = (failureCount: number, error: unknown) => {
  if (failureCount >= MAX_RETRIES) return false
  if (!isAxiosError(error)) return true
  if (error.code === AxiosError.ETIMEDOUT) return false // if axios timeout exceeded, don't retry.  Slow endpoint likely

  return error.response === undefined || error.response.status >= 500
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFunction,
      retry: shouldRetry,
    },
  },
})
